import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { UserNotifyService } from 'src/app/core/notify/user-notify.service';
import { GetTestReportService } from 'src/app/shared/services/api/test-report/get-test-report.service';
import { SendTestReportService } from 'src/app/shared/services/api/test-report/send-test-report.service';
import { GetVideoReportService } from 'src/app/shared/services/api/video-report/get-video-report.service';
import { SendVideoReportService } from 'src/app/shared/services/api/video-report/send-video-report.service';
import { testReportModel } from 'src/app/views/partials/test-report-bottomsheet/test-report-bottomsheet.component';

@Component({
  selector: 'app-report-video-bottom-sheet',
  templateUrl: './report-video-bottom-sheet.component.html',
  styleUrls: ['./report-video-bottom-sheet.component.scss']
})
export class ReportVideoBottomSheetComponent {

  reportId;
  reportOptions;
  btnSkeleton: boolean = false;
  selectedTest: Array<testReportModel> = [];
  selectedTestEnum = 0;
  reportTestDescription = '';
  sendReportForm: FormGroup


  constructor(
    private fb: FormBuilder,
    private bottomsheet: MatBottomSheet,
    private getVideoReportSevice: GetVideoReportService,
    private sendVideoReport: SendVideoReportService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data,
    private userNotify: UserNotifyService,

  ) {
    console.log('dataaaaa', data);

    this.reportId = data
    this.sendReportForm = this.fb.group({
      reportEnum: [0, [Validators.required]],
      reportDescription: ['', [Validators.required]]
    })
  }

  ngOnInit() {
    this.getReportTestOptions();

  }
  sendReport() {
    try {
      this.sendTestReportValidation();
    } catch (error) {
      this.userNotify.showWarning(`${error}`.split(':')[1]);
      return;
    }
    this.btnSkeleton = true;
    const sendTestReportModel = {
      VideoId: this.reportId,
      VideoErrorType: this.selectedTestEnum,
      Descrption: this.sendReportForm.get('reportDescription').value
    }
    console.log('testReportModelllllllllllllllllllllllll', sendTestReportModel);

    // const dataToReturn = { result: true };
    // this.bottomSheetRef.dismiss(dataToReturn);
    this.sendVideoReport.call(sendTestReportModel).subscribe(res => {
      console.log('sendTestReportRessssssss', res);
      this.btnSkeleton = false;
      this.onClosebottomSheet();
      this.userNotify.showSuccess('ممنون که با گزارشت به بهتر شدن تیک کمک می‌کنی')
    }, () => {
      this.btnSkeleton = false;
    })
  }
  sendTestReportValidation() {
    if (this.sendReportForm.get('reportEnum').value == 0 && this.sendReportForm.get('reportDescription').value === '') {
      throw new Error('حداقل یک گزینه رو انتخاب یا توضیحات اشکال ویدیو رو تکمیل کن.');
    } else {
      return;
    }
  }
  getTestReportEnum(test: testReportModel) {
    if (this.selectedTest.length === 0) {
      this.selectedTest.push(test)
      this.selectedTestEnum = test.state;

    } else {
      var seleeee = this.selectedTest.find(x => x.state === test.state);
      if (seleeee) {
        this.selectedTest = this.selectedTest.filter(x => {

          return x.state != test.state
        })
      } else {
        this.selectedTest.push(test);
        this.selectedTestEnum = this.selectedTestEnum + test.state
      }
    }
    this.selectedTestEnum = this.selectedTest.map(item => item.state).reduce((accumulator, current) => accumulator + current, 0)
    console.log('selected ', this.selectedTest, 'Enum', this.selectedTestEnum);

  }

  onClosebottomSheet() {
    this.bottomsheet.dismiss();
  }

  getReportTestOptions() {
    this.getVideoReportSevice.call().subscribe(res => {
      console.log('video report ......', res);
      this.reportOptions = res;

    })
  }
}
